/** Redoslijed prikaza: istaknuta putovanja → Last Minute → New → ostalo → Popunjeno. */

export const PINNED_TOUR_ORDER = [
  "alicante-listopad",
  "valladolid-san-lorenzo-rujan",
];

const LAST_PLACE_TOUR_KEYS = new Set(["valencia"]);

function pinnedSortIndex(key) {
  const index = PINNED_TOUR_ORDER.indexOf(key);
  return index === -1 ? PINNED_TOUR_ORDER.length : index;
}

function isLastPlaceTour(key) {
  return LAST_PLACE_TOUR_KEYS.has(key);
}

function tourTagSortPriority(tag) {
  if (tag === "Last Minute") return 0;
  if (tag === "New") return 1;
  if (tag === "Popunjeno") return 3;
  return 2;
}

function isPopunjenoTag(tag) {
  return String(tag || "").toLowerCase().includes("popunjeno");
}

function compareTourDates(a, b) {
  const dateA = new Date(a?.date || 0);
  const dateB = new Date(b?.date || 0);
  if (isPopunjenoTag(a?.tag) && isPopunjenoTag(b?.tag)) {
    return dateB - dateA;
  }
  return dateA - dateB;
}

export function compareToursForDisplay(a, b) {
  const pinDiff = pinnedSortIndex(a?.key) - pinnedSortIndex(b?.key);
  if (pinDiff !== 0) return pinDiff;

  const aLast = isLastPlaceTour(a?.key);
  const bLast = isLastPlaceTour(b?.key);
  if (aLast !== bLast) return aLast ? 1 : -1;

  const priorityDiff = tourTagSortPriority(a?.tag) - tourTagSortPriority(b?.tag);
  if (priorityDiff !== 0) return priorityDiff;
  return compareTourDates(a, b);
}

export function sortToursForDisplay(tours) {
  if (!Array.isArray(tours)) return [];
  return [...tours].sort(compareToursForDisplay);
}

export function splitFeaturedTours(tours) {
  if (!Array.isArray(tours)) return { featured: [], rest: [] };
  const byKey = new Map(tours.map((tour) => [tour.key, tour]));
  const featured = PINNED_TOUR_ORDER.map((key) => byKey.get(key)).filter(Boolean);
  const featuredKeys = new Set(featured.map((tour) => tour.key));
  const rest = tours.filter((tour) => !featuredKeys.has(tour.key));
  return { featured, rest };
}
